{
  "createFarmAddress_line_1": {
    "label": "Adresse Ligne 1",
    "placeholder": "(Entrez l'adresse de la ferme)"
  },
  "createFarmAddress_line_2": {
    "label": "Adresse ligne 2",
    "placeholder": null
  },
  "createFarmCity": {
    "label": "Ville",
    "placeholder": "(Entrez dans la ville)"
  },
  "createFarmCountry": {
    "label": "Pays",
    "placeholder": "(Choisir un pays)"
  },
  "createFarmDescription": "Sinon, si vous êtes le premier utilisateur de votre ferme, vous pouvez créer un compte de ferme. Ensuite, vous pouvez inviter d'autres utilisateurs à rejoindre votre ferme.",
  "createFarmHelpTitle": "À propos des comptes agricoles",
  "createFarmLinkTo": "Nouveau compte agricole",
  "createFarmName": {
    "label": "Nom",
    "placeholder": "(Entrez le nom de la ferme)"
  },
  "createFarmPostalCode": {
    "label": "Code Postal",
    "placeholder": "(Entrez le code postal)"
  },
  "createFarmRegion": {
    "label": "Région",
    "placeholder": "(Choisir une région)"
  },
  "createFarmTitle": "Nouveau compte agricole",
  "createNewFarmAccount": "Créer un nouveau compte de ferme",
  "enterFarmJoinCode": "Entrez le code d'adhésion à la ferme",
  "enterYourFarmAddress": "Entrez l'adresse de votre ferme",
  "farmAccountHelpBodyText": "Votre compte de ferme est une représentation d'une ferme réelle, qui sert de plaque tournante pour tous les éléments suivants :\n\nAppareils : vos appareils surveillent les équipements d'irrigation à l'aide de divers capteurs.\n\nChamps : les champs donnent un contexte aux mises à jour de l'état des appareils et regroupent les données d'irrigation en fonction de l'activité dans leurs limites.\n\nUtilisateurs : permet aux gestionnaires et aux employés de la ferme d'interagir avec le système FarmHQ.\n\nVos comptes de ferme sont distincts de votre compte utilisateur de plusieurs manières importantes. Il n'y a aucune information de connexion à retenir ; à la place, lorsque vous vous connectez à farmhq.com avec vos identifiants personnels, les appareils et les champs de votre ferme seront chargés automatiquement.\n\nQ : Puis-je rejoindre plusieurs comptes de ferme ?\n\nR : Oui. Une fois que vous êtes membre d'une ferme, vous pouvez naviguer vers une autre ferme et la rejoindre ou en créer une autre.",
  "farmAccountHelpTitle": "À propos des comptes agricoles",
  "farmJoinCodeLabel": "Code d'adhésion à la ferme",
  "ifAnotherUserHasAlreadyCreatedYourFarmAccount": "Si quelqu'un de votre ferme a déjà créé un compte de ferme, il peut vous donner un code d'adhésion à la ferme. Vous pouvez utiliser ce code pour lier votre compte d'utilisateur au compte de la ferme.",
  "instructions": "Ensuite, vous devez vous connecter à un compte de ferme.",
  "joinFarmAlreadyJoined": "Vous êtes déjà membre de ce compte ferme.",
  "joinFarmDescription": "Si quelqu'un de votre ferme a déjà créé un compte de ferme, il peut vous donner un code d'adhésion à la ferme.\n\nConnectez votre compte utilisateur au compte de la ferme en saisissant le code ci-dessous :",
  "joinFarmLinkTo": "Rejoindre un autre compte de ferme",
  "joinFarmTitle": "Rejoignez Farm With Code",
  "joinFarmWithCode": "Rejoignez Farm With Code",
  "joinFarmWithCodeHelpBodyText": "Les codes de connexion à la ferme permettent aux utilisateurs de lier leur compte utilisateur à un compte de ferme. En rejoignant un compte de ferme, les utilisateurs peuvent afficher et gérer tous les appareils associés à cette ferme.\n\nLes codes de connexion à la ferme sont des codes uniques à 6 caractères générés par le propriétaire de la ferme. Si vous êtes un utilisateur qui a reçu un code de connexion à la ferme, vous pouvez le saisir ici pour rejoindre le compte de la ferme.\n\nL'utilisateur qui a créé le code doit également décider de l'autorisation dont vous disposerez sur le compte de la ferme. Cela déterminera les actions que vous pouvez effectuer sur le compte de la ferme.",
  "joinFarmWithCodeHelpTitle": "À propos des codes d'adhésion à la ferme",
  "newFarmAccount": "Nouveau compte agricole",
  "noFarmsTitle": "Pas de fermes",
  "successAddDevices": {
    "description": "Enregistrez vos appareils FarmHQ",
    "text": "Ajouter des appareils"
  },
  "successDrawFields": {
    "description": "Dessinez les champs de votre ferme",
    "text": "Dessiner des champs"
  },
  "successInstructions": "Voici quelques façons de démarrer avec FarmHQ",
  "successTitle": "Succès",
  "successViewSupport": {
    "description": "Découvrez notre documentation d'assistance",
    "text": "Soutien"
  },
  "userAccountCreatedMessage": "Compte utilisateur créé",
  "welcomeToFarmHQ": "Bienvenue à FarmHQ",
  "whatWeUseFarmLocationForText": "Nous utilisons ces informations pour garantir le bon fonctionnement de nos fonctionnalités cartographiques. Nous ne partageons pas ces informations avec des tiers.",
  "whatWeUseFarmLocationForTitle": "Collecte d'adresses de fermes"
}
